module.exports = __webpack_public_path__ + "img/DOOM-Slayer.png";